<template>
  <section class="selectors-component">
    <div class="selectors-component__selectors-container">
      <div class="selectors-component__selectors-container__cont-competition">
        <div class="selectors-component__selectors-container__cont-competition__label">
          Competición:
        </div>
        <div class="selectors-component__selectors-container__cont-competition__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect v-model="selectedTournament" placeholder="Seleccione" expanded>
              <template v-for="tournament of tournaments">
                <option :key="tournament.id" :value="tournament">
                  {{ tournament.name }}
                </option>
              </template>
            </BSelect>
          </BField>
        </div>
      </div>
      <div class="selectors-component__selectors-container__cont-season">
        <div class="selectors-component__selectors-container__cont-season__label">
          Torneo:
        </div>
        <div class="selectors-component__selectors-container__cont-season__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect v-model="selectedSeason" placeholder="Seleccione" expanded>
              <template v-for="season of selectedTournament.seasons">
                <option :key="season.id" :value="season">
                  {{ season.name }}
                </option>
              </template>
            </BSelect>
          </BField>
        </div>
      </div>
    </div>
    <div class="selectors-component__separator"></div>
    <div class="selectors-component__logos-container">
      <div class="selectors-component__logos-container__container">
        <div class="selectors-component__logos-container__container__citec">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/logo_citec@2x.png" />
        </div>
        <div class="selectors-component__logos-container__container__separator"></div>
        <RouterLink class="navbar-item menu-golstats" :to="{ path: '/' }">
          <div>
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/logo_golstats@2x.png" />
          </div>
        </RouterLink>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SelectorsComponent',
  props: {
    tournaments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedTournament: {
        seasons: [],
      },
      selectedSeason: {},
    };
  },
  watch: {
    tournaments(newValue) {
      if (newValue && newValue.length) {
        this.selectedTournament = newValue.find(tournament => tournament.id === 1);
      }
    },
    selectedTournament(newValue) {
      if (newValue) {
        this.$emit('change-tournament', newValue);
        if (newValue.seasons && newValue.seasons.length) {
          this.selectedSeason = newValue.seasons[0];
        }
      }
    },
    selectedSeason(newValue) {
      const seasons = [
        {
          id: newValue.id,
          type: newValue.type,
        },
      ];
      for (const relatedSeason of newValue.related_seasons) {
        seasons.push({ id: relatedSeason.id, type: relatedSeason.type });
      }
      this.$emit('change-seasons', seasons);
    },
    getTournaments() {
      this.changeTournament(1);
    },
  },
};
</script>
<style>
.select-statistics select {
  font-family: 'Avenir-Demi-Medium';
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: -0.16px;
}
</style>
<style lang="scss" scoped>
.selectors-component {
  width: 100%;
  height: 56px;
  border-radius: 8px;
  border: solid 1px #bfc9d2;
  display: inline-flex;
  overflow: hidden;
  @media screen and (max-width: 1080px) {
    height: 64px;
  }
  @media screen and (max-width: 645px) {
    display: inline-block;
    height: 128px;
  }
  &__selectors-container {
    width: 50%;
    display: inline-flex;
    @media screen and (max-width: 1320px) {
      width: 55%;
    }
    @media screen and (max-width: 645px) {
      width: 96%;
      height: 56px;
    }
    &__cont-competition {
      width: 46%;
      display: inline-flex;
      align-items: center;
      align-content: center;
      @media screen and (max-width: 1080px) {
        display: inline-block;
        margin-left: 1%;
      }
      @media screen and (max-width: 645px) {
        width: 50%;
      }
      &__label {
        width: 40%;
        font-family: 'Avenir-Demi-Medium';
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: -0.16px;
        text-align: center;
        @media screen and (max-width: 1080px) {
          width: 100%;
          text-align: left;
          font-family: 'Roboto-Medium';
          font-size: 12px;
          font-weight: 500;
          font-stretch: normal;
          margin-top: 4px;
          font-style: normal;
          letter-spacing: normal;
          color: #95a3ae;
        }
      }
      &__selector {
        width: 60%;
        @media screen and (max-width: 1080px) {
          width: 98%;
        }
      }
    }
    &__cont-season {
      width: 53%;
      display: inline-flex;
      align-items: center;
      align-content: center;
      @media screen and (max-width: 1080px) {
        display: inline-block;
      }
      @media screen and (max-width: 645px) {
        width: 50%;
      }
      &__label {
        width: 40%;
        font-family: 'Avenir-Demi-Medium';
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: -0.16px;
        text-align: right;
        padding-right: 12px;
        @media screen and (max-width: 1320px) {
          padding-right: 15px;
        }
        @media screen and (max-width: 1080px) {
          width: 100%;
          text-align: left;
          font-family: 'Roboto-Medium';
          font-size: 12px;
          margin-top: 4px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          color: #95a3ae;
        }
      }
      &__selector {
        width: 60%;
        @media screen and (max-width: 1080px) {
          width: 98%;
        }
      }
    }
  }
  &__separator {
    width: 1%;
    @media screen and (max-width: 645px) {
      width: 94%;
      height: 1px;
      margin: 0 auto;
      margin-top: 10px;
      margin-bottom: 7px;
      border-top: 1px dotted #c5c7c9;
    }
  }
  &__logos-container {
    width: 49%;
    @media screen and (max-width: 1320px) {
      width: 44%;
    }
    @media screen and (max-width: 645px) {
      width: 94%;
      height: auto;
      margin: 0 auto;
    }
    &__container {
      width: 323px;
      height: 29px;
      margin-top: 13.5px;
      display: inline-flex;
      float: right;
      margin-right: 16px;
      @media screen and (max-width: 1080px) {
        margin-top: 23.5px;
      }
      @media screen and (max-width: 840px) {
        width: 303px;
        height: 29px;
      }
      @media screen and (max-width: 750px) {
        width: 283px;
        margin-right: 4px;
      }
      @media screen and (max-width: 680px) {
        width: 270px;
        margin-right: 4px;
      }
      @media screen and (max-width: 645px) {
        width: 100%;
        margin-top: 2px;
        height: 36px;
        float: none;
      }
      @media screen and (max-width: 380px) {
        margin-top: 8px;
      }
      &__citec {
        width: 144px;
        height: 29px;
        @media screen and (max-width: 645px) {
          width: 50%;
          height: 20px;
        }
        img {
          @media screen and (max-width: 645px) {
            width: 60%;
          }
          @media screen and (max-width: 580px) {
            width: 70%;
          }
          @media screen and (max-width: 510px) {
            width: 80%;
          }
          @media screen and (max-width: 435px) {
            width: 90%;
          }
          @media screen and (max-width: 370px) {
            width: 98%;
          }
        }
      }
      &__separator {
        width: 2px;
        height: 15px;
        border-left: 1px dotted #c5c7c9;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 7px;
        @media screen and (max-width: 750px) {
          margin-left: 10px;
          margin-right: 10px;
        }
        @media screen and (max-width: 645px) {
          width: 2px;
          height: 20px;
          margin-top: 8px;
        }
        @media screen and (max-width: 400px) {
          margin-top: 4px;
        }
      }
      &__golstats {
        width: 138px;
        height: 29px;
        @media screen and (max-width: 645px) {
          width: 49%;
          height: 46px;
        }
        img {
          @media screen and (max-width: 645px) {
            width: 60%;
          }
          @media screen and (max-width: 580px) {
            width: 70%;
          }
          @media screen and (max-width: 510px) {
            width: 80%;
          }
          @media screen and (max-width: 435px) {
            width: 90%;
          }
          @media screen and (max-width: 370px) {
            width: 98%;
          }
        }
      }
    }
  }
}
</style>
